// RoadZen (CPA / RSA provider, like Brisk) — page addresses, shared by the menu (Navbar/Menu.js), the routes
// (Routing/Routes.js) and the page map (Page/Dashboard/index.js).
export const ROADZEN_USERS_PATH = "/roadzenUsers";
export const ROADZEN_WALLET_PATH = "/roadzenWallet";
export const ROADZEN_CREATE_CERT_PATH = "/roadzenCreateCertificate";
export const ROADZEN_CERT_LIST_PATH = "/roadzenCertificateList";
// Zen Wallet: the agency's Company Wallet "RoadZen" (like the Brisk Wallet); not RoadZen's own wallet of a seller
export const ROADZEN_COMPANY_WALLET_PATH = "/zenWallet";
